package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.pages.main.view.map.MapOverlayCard
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.validate
import com.nonopn.skywatcher.design.local.LocalConfirmPopup
import com.nonopn.skywatcher.design.utils.localized
import eu.codlab.compose.widgets.TextNormal

@Composable
fun EstimateViewAdminValidationButton(
    modifier: Modifier = Modifier,
    model: EstimateScreenModel,
) {
    val popup = LocalConfirmPopup.current

    MapOverlayCard(
        modifier = modifier,
        columnModifier = Modifier.width(IntrinsicSize.Min)
            .height(IntrinsicSize.Min),
        onClick = {
            model.validateEstimate(popup)
        }
    ) {
        Column(Modifier.padding(16.dp)) {
            TextNormal(Res.string.validate.localized())
        }
    }
}
